var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('el-container',[_c('el-aside',{attrs:{"width":"255px"}},[_c('crmAside')],1),_c('el-container',[_c('el-header',{attrs:{"height":"90px"}},[_c('crmHeader')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }